export default __webpack_public_path__ + "static/media/15.0d05f95a.jpg";